import React, { useState } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import "./admin.css";
import Dashboard from "./Dashboard";
import AboutAdmin from "./AboutAdmin";
import HeaderAdmin from "./HeaderAdmin";
import ContactAdmin from "./ContactAdmin";
import PortfolioAdmin from "./PortfolioAdmin";
import ServiceAdmin from "./ServiceAdmin";
import ExperienceAdmin from "./ExperienceAdmin";
import Site from "./Site";
import Cookies from "js-cookie";
import MOI from "../../assets/templates/aubin.jpg";
import COMPANY from "../../assets/templates/MAAUTECH.png";
import { FaBars, FaTimes } from "react-icons/fa";
import ThemeToggle from "../Toggle/toggle";

const AdminSidebar = ({ setIsAuthenticated }) => {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (sectionId) => {
    setActiveSection(sectionId);
    // setIsOpen(false);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    setIsAuthenticated(false);
    setActiveSection("logout");
    navigate("/");
  };

  return (
    <div className="container_admin">
      {/* Hamburger Icon */}
      <div className="hamburger" onClick={handleToggle}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>
      {/* Sidebar */}
      {isOpen && (
        <>
          <div className="overlay" onClick={handleToggle}></div>
          <div className={`sidebar_admin ${isOpen ? "open" : ""}`}>
            {/* Company Logo */}
            <div className="logo">
              <img src={COMPANY} alt="Company Logo" />
              <span>Welcome 🙂🙂</span>
            </div>

            <Link
              to="/admin/dashboard"
              onClick={() => handleNavigation("dashboard")}
              className={activeSection === "dashboard" ? "active" : ""}
            >
              Dashboard
            </Link>
            <Link
              to="/admin"
              onClick={() => handleNavigation("site")}
              className={activeSection === "site" ? "active" : ""}
            >
              Site
            </Link>
            <Link
              to="/admin/header"
              onClick={() => handleNavigation("header")}
              className={activeSection === "header" ? "active" : ""}
            >
              Header
            </Link>
            <Link
              to="/admin/about"
              onClick={() => handleNavigation("about")}
              className={activeSection === "about" ? "active" : ""}
            >
              About
            </Link>
            <Link
              to="/admin/portfolio"
              onClick={() => handleNavigation("portfolio")}
              className={activeSection === "portfolio" ? "active" : ""}
            >
              Portfolio
            </Link>
            <Link
              to="/admin/service"
              onClick={() => handleNavigation("service")}
              className={activeSection === "service" ? "active" : ""}
            >
              Service
            </Link>
            <Link
              to="/admin/contact"
              onClick={() => handleNavigation("contact")}
              className={activeSection === "contact" ? "active" : ""}
            >
              Contact
            </Link>
            <Link
              to="/admin/experience"
              onClick={() => handleNavigation("experience")}
              className={activeSection === "experience" ? "active" : ""}
            >
              Experience
            </Link>
            <Link
              to="/"
              onClick={handleLogout}
              className={activeSection === "logout" ? "active" : ""}
            >
              Logout
            </Link>

            {/* User Profile Section */}
            <div className="user-profile">
              <img src={MOI} alt="User" />
              <span>Aubin SIAHA</span>
              <div className="theme-toggle_admin">
                <ThemeToggle />
              </div>
            </div>
          </div>
        </>
      )}

      {/* Content Area */}
      <div className="content-area">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/header" element={<HeaderAdmin />} />
          <Route path="/about" element={<AboutAdmin />} />
          <Route path="/portfolio" element={<PortfolioAdmin />} />
          <Route path="/service" element={<ServiceAdmin />} />
          <Route path="/contact" element={<ContactAdmin />} />
          <Route path="/experience" element={<ExperienceAdmin />} />
          <Route path="/" element={<Site />} />
          {/* <Route path="/logout" element={<Login />} /> */}
        </Routes>
      </div>
    </div>
  );
};

export default AdminSidebar;
